export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";